import axios from 'axios';

import { API_BASE_URL } from '../config/apiBase';

// Tolerância para relógio do aparelho adiantado: o servidor decide a expiração real.
const CLOCK_SKEW_MS = 60 * 1000;

const decodePayload = (token) => {
  try {
    const part = String(token).split('.')[1];
    if (!part) return null;
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(window.atob(base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')));
  } catch {
    return null;
  }
};

// Só lê a validade para evitar mostrar a área logada com token vencido.
// A autorização continua no servidor, que relê papel, organização e conta ativa.
export function adminTokenExpiryMs(token) {
  const payload = decodePayload(token);
  return Number.isFinite(payload?.exp) ? payload.exp * 1000 : null;
}

export function hasUsableAdminToken(token, nowMs = Date.now()) {
  if (!token) return false;
  const expiresMs = adminTokenExpiryMs(token);
  return expiresMs != null && expiresMs + CLOCK_SKEW_MS > nowMs;
}

const SESSION_ENDED_STATUS = new Set([401, 403]);
let pending = null;
let pendingToken = null;

// Uma revalidação por token e por carregamento da página; rotas e requisições
// simultâneas reaproveitam a mesma promessa.
export function revalidateAdminSession(token, client = axios) {
  if (pending && pendingToken === token) return pending;
  pendingToken = token;
  pending = client.get(`${API_BASE_URL}/auth/session`, {
    headers: { Authorization: `Bearer ${token}` },
    timeout: 15000,
  })
    .then((response) => ({ status: 'valid', user: response?.data?.user || null }))
    .catch((error) => {
      const status = error?.response?.status;
      if (SESSION_ENDED_STATUS.has(status)) {
        return { status: 'ended', message: error?.response?.data?.message || '' };
      }
      return { status: 'unverified' };
    });
  return pending;
}

export function resetAdminRevalidation() {
  pending = null;
  pendingToken = null;
}
